'use client'
import { useState } from 'react'
import styles from './styles.module.css'
import Image from '@/shared/components/Image/new'
import Video from '../Video'
import Author from '../Author'

export const Liveblogs = (props) => {
    const CONTENT_DEFAULT_CLIPPING = "Vertical_Libre_870x0"

    const [showCopied, setShowCopied] = useState(false)
    const handleCopyCurrentUrl = async (anchorId) => {
        try {
            const url = `${window.location.origin}${window.location.pathname}#${anchorId}`
            await navigator.clipboard.writeText(url)
            setShowCopied(true)

            setTimeout(() => {
                setShowCopied(false)
            }, 2000)
        } catch (error) {
            console.error('No se pudo copiar la URL:', error)
        }
    }

    const getDateInfo = (dateParagraph = '') => {
        if (!dateParagraph) {
            return {
                formattedDate: '',
                nameDayWeek: '',
                hour: ''
            }
        }

        const originalDate = dateParagraph.split(' ')
        const date = originalDate[0]
        const hour = originalDate?.[1]?.slice(0, 5) || ''

        const datePart = date.split('-')
        const formattedDate = `${datePart[2]}.${datePart[1]}.${datePart[0]}`

        const day = parseInt(datePart[2], 10)
        const month = parseInt(datePart[1], 10)
        const year = parseInt(datePart[0], 10)

        const objectDate = new Date(year, month - 1, day)
        const dayWeekNumber = objectDate.getDay()

        const weekdays = ["Dom.", "Lun.", "Mar.", "Mié.", "Jue.", "Vie.", "Sáb."]
        const nameDayWeek = weekdays[dayWeekNumber]

        return {
            formattedDate,
            nameDayWeek,
            hour
        }
    }

const dateParagraphTemplate = (dateParagraph = '', index, anchorId) => {
            if (!dateParagraph) return null

        const { formattedDate, nameDayWeek, hour } = getDateInfo(dateParagraph)

        return (
            <>
                {index !== 0 && <div className={styles['sinline']}></div>}

                <span className={styles['date-update']}>
                    <span className={styles['hour-n']}> {hour} </span>
                    <span className={styles['day-n']}>/ {nameDayWeek} {formattedDate} </span>                    
                </span>

                <div className={styles['date-cont']}>
                    <span className={styles['icon-back']}>
                        <a aria-label="Copiar Link de la Nota" title="Copiar Link de la Nota" onClick={() => handleCopyCurrentUrl(anchorId)}>
                            <svg
                                stroke="currentColor"
                                fill="none"
                                strokeWidth="2"
                                viewBox="0 0 24 24"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                height="1em"
                                width="1em"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <rect x="9" y="9" width="12" height="12" rx="2" ry="2"></rect>
                                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                            </svg>
                        </a>
                    </span>
                </div>
            </>
        )
    }

    const authorTemplate = (authorParagraph) => {
        const parseObjectAuthorParagraph = {
            ...authorParagraph,
            imageUrl: authorParagraph?.imageUrl.replace(
                'http://img-ellitoral.lilax.io',
                process.env.NEXT_PUBLIC_IMAGE_DOMAIN
            )
        }

        return authorParagraph && (
            <div className={styles['author-container']}>
                <Author author={parseObjectAuthorParagraph} />
            </div>
        )
    }

    const textTemplate = (data) => {
    let parseTitle = data.value

    if (data.value.includes('h2')) {
        const { hour } = getDateInfo(data?.dateParagraph)

        const firstPartHtmlTitle = data.value.slice(0, 4)
        const secondPartHtmlTitle = data.value.slice(4)

        // 👇 acá agregás el color amarillo resaltado si está "activo"
        const titleStyle = data.rating
            ? 'style="text-decoration: underline; text-decoration-skip-ink: none; text-underline-offset: -9px; text-decoration-color: yellow; text-decoration-thickness: 12px;"'
            : ''

        parseTitle = `${firstPartHtmlTitle.replace(
            '<h2',
            `<h2 ${titleStyle}`
        )}${secondPartHtmlTitle}`
    }

    return (
        <>
            {authorTemplate(data?.authorParagraph)}

            <div
                className={styles['paragraph']}
                dangerouslySetInnerHTML={{ __html: parseTitle }}
            ></div>
        </>
    )
}

    const lilanewsTemplate = (data) => {
        const title = data?.value?.title || ''
        const url = data?.value?.url || ''
        const summary = data?.value?.summary || ''

        const cleanSummary = summary.replace(/<[^>]*>/g, '').trim()
        const destacada = !data.rating ? 'normal' : 'destacada'

        return (
            <>
                {authorTemplate(data?.authorParagraph)}

                <div className={styles['lilanews-container']}>
                    <h2 className={styles['lilanews-title']}>
                        {title}
                    </h2>

                    {cleanSummary && (
                        <p className={styles['lilanews-summary']}>
                            {cleanSummary}
                        </p>
                    )}

                    <a
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles['lilanews-cta']}
                    >
                        <b className={styles['continuar']}>Continuar leyendo →</b>
                    </a>
                </div>
            </>
        )
    }

    const embedTemplate = (data) => {
        return (
            <div
                className={styles['embed-container']}
                dangerouslySetInnerHTML={{ __html: data.value?.html }}
            ></div>
        )
    }

    const imageTemplate = (data) => {
        const defaultClipping = data.value?.clippings.filter(
            (el) => el._id === CONTENT_DEFAULT_CLIPPING
        )

        const newClippingImg = !data.value?.manualCrops?.[0]
            ? defaultClipping[0]
            : data.value?.manualCrops?.[0]

        const finalClipping = !newClippingImg
            ? data.value?.clippings?.[0]
            : newClippingImg

        const imgLiveblogs = `${process.env.NEXT_PUBLIC_IMAGE_DOMAIN}/images${finalClipping?.url}`

        return (
            <Image
                src={imgLiveblogs}
                width={finalClipping?.dimensions?.width}
                height={finalClipping?.dimensions?.height}
                className={styles['cover-image']}
            />
        )
    }

    const videoTemplate = (data) => {
        return (
            <div className={styles['video-container-liveblogs']}>
                <Video content={data.value} />
            </div>
        )
    }

    const getDynamicTemplate = (data) => {
        switch (data.type) {
            case 'text':
                return textTemplate(data)
            case 'embed':
            case 'freehtml':
                return embedTemplate(data)
            case 'image':
                return imageTemplate(data)
            case 'video':
                return videoTemplate(data)
            case 'lilanews':
                return lilanewsTemplate(data)
            default:
                return null
        }
    }

    // 🔥 AGRUPADOR POR FECHA
    const groupByDate = (items = []) => {
        const groups = []
        let currentGroup = null

        items.forEach((item) => {
            if (item.dateParagraph) {
                if (currentGroup) {
                    groups.push(currentGroup)
                }

                currentGroup = {
                    date: item.dateParagraph,
                    items: [item]
                }
            } else if (currentGroup) {
                currentGroup.items.push(item)
            }
        })

        if (currentGroup) {
            groups.push(currentGroup)
        }

        return groups
    }

    const groupedContent = groupByDate(props.content.body)

   return (
    <div className={styles['container-liveblog']}>
        {groupedContent.map((group, groupIndex) => {
            const anchorId = `liveblog-${groupIndex}`

            return (
                <div
                    key={groupIndex}
                    id={anchorId}
                    className={styles['liveblog-group']}
                >
                    {dateParagraphTemplate(group.date, groupIndex, anchorId)}

                    {group.items.map((el, i) => {
                        const CustomTemplate = getDynamicTemplate(el)

                        return (
                            <div key={i} className={styles['liveblog-item']}>
                                {CustomTemplate}
                            </div>
                        )
                    })}
                </div>
            )
        })}

        {showCopied && (
            <div className={styles['copied-toast']}>
                Link copiado
            </div>
        )}
    </div>
)
}